import { infoBarTypes } from '../types'

export const closeBar = () => ({ type: infoBarTypes.CLOSE_BAR })